// extracted by mini-css-extract-plugin
export default {"root":"style_root__5-VuW","mobile":"style_mobile__dRCmM","hideNotifiaction":"style_hideNotifiaction__VxETm"};